// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"search-SearchCollectionItem__wrapper--2guaq","participants":"search-SearchCollectionItem__participants--1YGdI","title":"search-SearchCollectionItem__title--1CiJO"};